import React, { memo, useEffect, useState, useRef } from 'react';
import { FixedSizeList as List } from 'react-window';
import SizeSystemItem from './SizeSystemItem';

const BigDataList = memo(({ bigData, ...rest }) => {
  const [bigDataArray, setBigDataArray] = useState([]);
  const [listWidth, setListWidth] = useState(0);
  const containerRef = useRef(null);

  // Function to flatten the bigData object
  function flattenBigData(obj) {
    let systemsArr = Object.values(obj).map((system) => {
      let sizes = [];
      if (system.open) {
        sizes = Object.values(system.sizes).map((size) => {
          let preparedSize = { ...size, type: 'size', systemId: system.id };
          return [preparedSize];
        });
      }
      let preparedSystem = { ...system, type: 'system' };
      return [preparedSystem, ...sizes.flat()];
    });
    return systemsArr.flat();
  }

  // Flatten bigData whenever it changes
  useEffect(() => {
    if (bigData) {
      setBigDataArray(flattenBigData(bigData));
    }
  }, [bigData]);

  // Handle container resizing
  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        setListWidth(containerRef.current.offsetWidth);
      }
    };

    const resizeObserver = new ResizeObserver(() => handleResize());
    const currentContainer = containerRef.current;
    if (currentContainer) {
      resizeObserver.observe(currentContainer);
    }

    // Set initial width
    handleResize();

    // Clean up observer on component unmount
    return () => {
      if (currentContainer) {
        resizeObserver.unobserve(currentContainer);
      }
    };
  }, []);

  return (
    <div ref={containerRef} style={{ flexGrow: 1, width: '100%', overflow: 'hidden' }}>
      <List
        height={800}
        itemCount={bigDataArray.length}
        itemSize={32}
        width={listWidth} // Set width dynamically based on container
      >
        {({ index, style }) => (
          <div style={style}>
            <SizeSystemItem
              key={`${bigDataArray[index].id}_${bigDataArray[index].systemId}_${bigDataArray[index].sizeId}`}
              index={index}
              arrayItem={bigDataArray[index]}
              {...rest}
            />
          </div>
        )}
      </List>
    </div>
  );
});

export default BigDataList;
